import { Label } from 'components/atoms';
import { PublicPage } from 'components/templates';
import { t } from 'i18next';
import { PiCaretLeft } from 'react-icons/pi';
import { useNavigate } from 'react-router-dom';
import { useGetAppHealth } from 'services/health';

const Health = () => {
  const health = useGetAppHealth();

  const navigate = useNavigate();

  return (
    <PublicPage
      footer={
        <div
          className='flex gap-2 cursor-pointer p-4 items-center'
          onClick={() => navigate('/login')}>
          <PiCaretLeft />
          {t('reset-password-request.back')}
        </div>
      }>
      {health.isLoading ? (
        '...'
      ) : health.data?.status === 200 ? (
        <Label color='green' withText>
          Healthy
        </Label>
      ) : (
        <Label color='red' withText>
          Not healthy
        </Label>
      )}
    </PublicPage>
  );
};

export default Health;
